module.exports = __webpack_public_path__ + "img/GainEndurance.447201c5.png";